module.exports = __webpack_public_path__ + "./assets/83b568f7b7f658b483b7fdda15ca95cf.svg";